var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44911 0.194977L9.31434 4.06082C9.7284 4.47488 9.43544 5.18265 8.85047 5.18265H1.11805C0.533091 5.18265 0.240123 4.47488 0.653208 4.06082L4.51942 0.194977C4.77626 -0.0617371 5.19227 -0.0617371 5.44911 0.194977ZM4.54872 13.8052L0.682505 9.93924C0.269419 9.5253 0.562388 8.81754 1.14735 8.81754H8.87977C9.46473 8.81754 9.7577 9.5253 9.34364 9.93924L5.4784 13.8052C5.22157 14.0618 4.80555 14.0618 4.54872 13.8052Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDouble);
export default __webpack_public_path__ + "static/media/caretDouble.92fd3746e1fab6bae007c846b6bb1c91.svg";
export { ForwardRef as ReactComponent };